import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { useQuoteActions } from 'quotes/hooks';
import { IVendorQuote } from 'quotes/types';

interface IProps {
  quote: IVendorQuote;
}

export const SendToVendorButton = ({ quote }: IProps) => {
  const { t } = useTranslation();

  const { sendVendorQuoteToVendor, isSendVendorQuoteToVendorLoading } = useQuoteActions();

  const onClick = () => {
    sendVendorQuoteToVendor({ quoteId: quote.id });
  };

  return (
    <Button
      text={t('buttonLabelSendToVendor')}
      onClick={onClick}
      disabled={isSendVendorQuoteToVendorLoading}
    />
  );
};
